import { Card, Flex, Image, styled } from '@grupoboticario/flora-react';

const styles = {
  Wrapper: styled(Flex, {
    alignItems: 'center',
    minHeight: '100vh',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '$15 0',
    overflow: 'hidden',

    "&[data-brand='bot']": {
      backgroundImage: 'url(/images/background-login-boticario-mobile.svg)',
      '@tablet': {
        backgroundImage: 'url(/images/background-login-boticario-desktop.svg)',
      },
      '@ultrawide': {
        backgroundImage: 'url(/images/background-login-boticario-ultrawide.svg)',
      },
      backgroundSize: 'cover',
    },
    "&[data-brand='eud']": {
      backgroundColor: '$backgroundTertiary',
    },
  }),

  Card: styled(Card, {
    padding: '$5',
    width: '100%',
    margin: '$4',
    maxWidth: 'calc(10 * $10)',
    zIndex: '1',
    '@tablet': {
      margin: '0',
    },
  }),

  LogoGrupoBoticario: styled(Image, {
    marginTop: '$4',
    '@tablet': {
      marginTop: '$19',
    },
  }),

  BannersWrapper: styled(Flex, {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  Banner: styled(Image, {
    maxWidth: 'calc(4 * $23)',
    width: '25vw',
    display: 'none',
    visibility: 'hidden',
    '@tablet': {
      display: 'initial',
      visibility: 'initial',
    },
  }),
};

export default styles;
